import { apiPost } from '../_common';

export default {
  exportPurchaseOrders(request) {
    return apiPost('/magenta/stock/bling/purchase-order', request).then(result => result.response);
  },
};
